import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const GraphIconV2Icon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={43} height={38} viewBox="0 0 43 38" fill="none" {...props}>
          <Rect width="43" height="38" rx="8" fill="#FFF5DD" />
          <Path
            d="M31.0078 27.3184H13.4762V27.3152C13.0661 27.3152 12.6948 27.1457 12.427 26.8741C12.1609 26.604 11.9953 26.2288 11.9953 25.8143H11.9922V10.6797H13.8894V25.3951H31.0078V27.3184ZM24.8937 17.8388H27.919C28.08 17.8388 28.2115 17.9723 28.2115 18.1355V24.1737C28.2115 24.337 28.08 24.4704 27.919 24.4704H24.8937C24.7327 24.4704 24.6012 24.337 24.6012 24.1737V18.1371C24.6012 17.9738 24.7327 17.8388 24.8937 17.8388ZM15.9166 14.1446H18.942C19.1029 14.1446 19.2345 14.2781 19.2345 14.4414V24.1753C19.2345 24.3385 19.1029 24.472 18.942 24.472H15.9166C15.7557 24.472 15.6242 24.3385 15.6242 24.1753V14.4414C15.6242 14.2781 15.7557 14.1446 15.9166 14.1446ZM20.4059 12.066H23.4297C23.5907 12.066 23.7222 12.1994 23.7222 12.3627V24.1753C23.7222 24.3385 23.5907 24.472 23.4297 24.472H20.4059C20.245 24.472 20.1134 24.3385 20.1134 24.1753V12.3627C20.1134 12.1994 20.245 12.066 20.4059 12.066Z"
            fill="#453B3B"
          />
        </Svg>
      </View>
    );
  },
);

export { GraphIconV2Icon };
